import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Link, useNavigate } from 'react-router-dom'
import { FileText, Search, ChevronRight } from 'lucide-react'
import { api } from '@/lib/api'
import { enterAbrePrimeiro } from '@/lib/keyboard'

interface FichaLista {
  id: number
  produto_id: number
  descricao: string | null
  tempo_producao_min: number
  rendimento_kg: string
  versao: number
  revisao: string
  ativa: boolean
  categoria: string | null
  observacoes: string | null
}

export default function IndFichasPage() {
  const nav = useNavigate()
  const [busca, setBusca] = useState('')

  const { data = [], isLoading } = useQuery<FichaLista[]>({
    queryKey: ['ind-fichas'],
    queryFn: async () => (await api.get('/industrial/fichas')).data,
  })

  const filtradas = busca
    ? data.filter((f) => (f.descricao || '').toLowerCase().includes(busca.toLowerCase()))
    : data

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <FileText className="text-brand-600" /> Fichas Técnicas
          </h1>
          <p className="text-sm text-ink-500">
            {data.length} fichas — clique em uma pra editar a composição (BOM)
          </p>
        </div>
      </div>

      <div className="relative max-w-md">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-400" />
        <input
          className="input pl-9 w-full"
          placeholder="Buscar por nome..."
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          onKeyDown={enterAbrePrimeiro(filtradas, (f) => nav(`/industrial/fichas/${f.id}`))}
        />
      </div>

      {isLoading && <div className="text-center py-6 text-ink-400">Carregando…</div>}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {filtradas.map((f) => (
          <Link
            key={f.id}
            to={`/industrial/fichas/${f.id}`}
            className="bg-white border border-ink-200 rounded-lg p-3 hover:border-brand-400 hover:shadow-md transition group"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1 min-w-0">
                <div className="text-xs font-mono text-ink-500">Ficha #{f.id}</div>
                <div className="font-semibold text-ink-900 truncate">{f.descricao || '(sem nome)'}</div>
                <div className="text-xs text-ink-500 mt-1">
                  Rend: {Number(f.rendimento_kg).toFixed(2)} kg · v{f.versao}{f.revisao} · {f.tempo_producao_min}min
                </div>
              </div>
              <ChevronRight size={16} className="text-ink-400 group-hover:text-brand-600 flex-shrink-0" />
            </div>
          </Link>
        ))}
      </div>

      {filtradas.length === 0 && !isLoading && (
        <div className="text-center py-10 text-ink-500">
          {busca ? 'Nenhuma ficha encontrada pra esse filtro.' : 'Nenhuma ficha cadastrada.'}
        </div>
      )}
    </div>
  )
}
